import shortNumber from 'short-number';

export default {
    install (Vue) {
        Object.defineProperties(Vue.prototype, {
            $shortNumber: {
                get: function () {
                    return shortNumber;
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/prototypes/short-number.js